module.exports = __webpack_public_path__ + "img/logo-full.f4a63726.svg";